import { useEffect, useRef } from 'react';
import { useState } from 'react';
import { createContext } from 'react';

const BasicDetailContext = createContext();

export default BasicDetailContext;

export const BasicDetailContextProvider = ({ children }) => {
    // State variables to manage tab data and active tab
    const [tabs, setTabs] = useState([]);
    const [eventId, setEventId] = useState(0);
    const [eventTimeSlotId, setEventTimeSlotId] = useState(0);
    const [activeTab, setActiveTab] = useState(0);
    //Basic Information Page - State
    const [entryType, setEntryType] = useState(1);
    //Availability And Schedule Page - State
    const [redirectionFlag, setRedirectionFlag] = useState(false);
    const [scheduleType, setScheduleType] = useState("physical");
    const [ScheduleListData, setScheduleListData] = useState([]);
    //Pricing Page - state
    const [isPricingApplicable, setIsPricingApplicable] = useState("cost");
    //Others Page - state
    const [isRequiredAdditionalInformation, setIsRequiredAdditionalInformation] = useState('no');
    const [questionTypeList, setQuestionTypeList] = useState([]);
    const [feedbackQuestionTypeList, setFeedQuestionTypeList] = useState([]);

    //pricing package
    const [pricingPackageDetails, setPricingPackageDetails] = useState([]);
    const [alowPricingEdit, setAlowPricingEdit] = useState(true);

    //AddOns
    const [addOnsData, setAddOnsData] = useState([]);

    const [isDietry, setIsDietry] = useState(false);


    return (
        <BasicDetailContext.Provider value={{
            eventId, setEventId,
            eventTimeSlotId, setEventTimeSlotId,
            tabs, setTabs,
            activeTab, setActiveTab,
            entryType, setEntryType,
            redirectionFlag, setRedirectionFlag,
            scheduleType, setScheduleType,
            ScheduleListData, setScheduleListData,
            isPricingApplicable, setIsPricingApplicable,
            isRequiredAdditionalInformation, setIsRequiredAdditionalInformation,
            questionTypeList, setQuestionTypeList,
            feedbackQuestionTypeList, setFeedQuestionTypeList,
            pricingPackageDetails, setPricingPackageDetails,
            alowPricingEdit, setAlowPricingEdit,
            addOnsData, setAddOnsData,
            isDietry, setIsDietry

        }}>
            {children}
        </BasicDetailContext.Provider>
    );
};